import { COLOURS } from '../../../../../ui-kit';

export const userColors = [
{ color: COLOURS.userComment.cerulean, darken: false },
{ color: COLOURS.userComment.heartfeltVermillion, darken: true },
{ color: COLOURS.userComment.unsafeOchre, darken: false },
{ color: COLOURS.userComment.snapMint, darken: true },
{ color: COLOURS.userComment.shallowOrchid, darken: true },
{ color: COLOURS.userComment.archetypal, darken: false },
{ color: COLOURS.userComment.horseDrawnPansy, darken: false },
{ color: COLOURS.userComment.gulliblePlatinum, darken: true }];